import { apiRemote } from '../../Services/RemoteService';

class SyncAPI {
  static getPropertySyncLedgers() {
    return apiRemote.get(`admin/integrations/sync-ledger`);
  }
}

export default SyncAPI;
